import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter, Youtube } from 'lucide-react';
import { FaHotel } from "react-icons/fa";

const Footer = () => {
  return (
    <div className="bg-gradient-to-br from-gray-900 via-gray-800 to-amber-900 text-white pt-12 pb-8">
      <div className="max-w-7xl mx-auto px-4">
        
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          
          {/* Hotel Info */}
          <div className="space-y-6">
            <div>
              <h2 className="text-2xl font-bold mb-2 flex items-center gap-2">
  <FaHotel className="text-amber-400 text-2xl" />
  Hotel Prakash Palace
</h2>

              <p className="text-gray-300 text-sm leading-relaxed">
                Welcome to Hotel Prakash Palace. Designed for both business and leisure travelers with premium amenities and traditional hospitality.
              </p>
            </div>
            
            {/* Social Media */}
            <div>
              <h4 className="font-semibold mb-3 text-gray-200">Follow Us</h4>
              <div className="flex gap-4">
                <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-amber-600 rounded-full flex items-center justify-center transition-colors">
                  <Facebook className="w-5 h-5" />
                </a>
                <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-amber-600 rounded-full flex items-center justify-center transition-colors">
                  <Instagram className="w-5 h-5" />
                </a>
                <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-amber-600 rounded-full flex items-center justify-center transition-colors">
                  <Twitter className="w-5 h-5" />
                </a>
                <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-amber-600 rounded-full flex items-center justify-center transition-colors">
                  <Youtube className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="space-y-6">
            <h3 className="text-xl font-bold mb-4 text-amber-300">Contact Information</h3>
            
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-amber-900/30 rounded-lg flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-5 h-5 text-amber-400" />
                </div>
                <div>
                  <p className="text-gray-300 text-sm">
                    BHU – Assi Ghat Road. B30/2-175K Lanka,<br />
                    Varanasi 221005 (U.P)
                  </p>
                </div>
              </div>
              
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-amber-900/30 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Phone className="w-5 h-5 text-amber-400" />
                </div>
                <div>
                  <a href="tel:+919119641118" className="text-gray-300 hover:text-amber-300 transition-colors text-sm block">
                    +91 9119641118
                  </a>
                  <a href="tel:+919415224017" className="text-gray-300 hover:text-amber-300 transition-colors text-sm block">
                    +91 9415224017
                  </a>
                </div>
              </div>
              
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-amber-900/30 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Mail className="w-5 h-5 text-amber-400" />
                </div>
                <div>
                  <a href="mailto:hotelprakashpalacevns@gmail.com" className="text-gray-300 hover:text-amber-300 transition-colors text-sm break-all">
                    hotelprakashpalacevns@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Company Links */}
          <div className="space-y-6">
            <h3 className="text-xl font-bold mb-4 text-amber-300">Company</h3>
            
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <h4 className="font-semibold text-gray-200 text-sm mb-2">Information</h4>
                <ul className="space-y-1">
                  <li><a href="#" className="text-gray-300 hover:text-amber-300 transition-colors text-sm">About Us</a></li>
                  <li><a href="#" className="text-gray-300 hover:text-amber-300 transition-colors text-sm">Contact Us</a></li>
                  <li><a href="#" className="text-gray-300 hover:text-amber-300 transition-colors text-sm">Privacy Policy</a></li>
                  <li><a href="#" className="text-gray-300 hover:text-amber-300 transition-colors text-sm">Terms & Conditions</a></li>
                </ul>
              </div>
              
              <div className="space-y-2">
                <h4 className="font-semibold text-gray-200 text-sm mb-2">Quick Links</h4>
                <ul className="space-y-1">
                  <li><a href="#" className="text-gray-300 hover:text-amber-300 transition-colors text-sm">Home</a></li>
                  <li><a href="#" className="text-gray-300 hover:text-amber-300 transition-colors text-sm">Contact</a></li>
                  <li><a href="#" className="text-gray-300 hover:text-amber-300 transition-colors text-sm">Help</a></li>
                  <li><a href="#" className="text-gray-300 hover:text-amber-300 transition-colors text-sm">FAQ</a></li>
                </ul>
              </div>
            </div>
          </div>

          {/* Services */}
          <div className="space-y-6">
            <h3 className="text-xl font-bold mb-4 text-amber-300">Services</h3>
            
            <div className="space-y-3">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-amber-400 rounded-full"></div>
                <span className="text-gray-300 text-sm">Food & Restaurant</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-amber-400 rounded-full"></div>
                <span className="text-gray-300 text-sm">Sports & Gaming</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-amber-400 rounded-full"></div>
                <span className="text-gray-300 text-sm">Event & Party</span>
              </div>
         
            </div>
            
            {/* Newsletter */}
            <div className="pt-4">
              <h4 className="font-semibold mb-2 text-gray-200 text-sm">Stay Updated</h4>
              <div className="flex">
                <input 
                  type="email" 
                  placeholder="Your email" 
                  className="flex-1 px-3 py-2 bg-gray-800 border border-gray-700 rounded-l-lg text-sm focus:outline-none focus:border-amber-500"
                />
                <button className="px-4 bg-gradient-to-r from-amber-600 to-orange-600 text-white rounded-r-lg text-sm font-medium hover:from-amber-500 hover:to-orange-500 transition-colors">
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 my-8"></div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-center md:text-left">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Hotel Prakash Palace, All Rights Reserved.
            </p>
            <p className="text-gray-500 text-xs mt-1">
              Designed By <span className="text-amber-400">MD SOFT</span>
            </p>
          </div>
          
          <div className="flex items-center gap-6">
            <a href="#" className="text-gray-300 hover:text-amber-300 transition-colors text-sm">Home</a>
            <a href="#" className="text-gray-300 hover:text-amber-300 transition-colors text-sm">Contact</a>
            <a href="#" className="text-gray-300 hover:text-amber-300 transition-colors text-sm">Help</a>
            <a href="#" className="text-gray-300 hover:text-amber-300 transition-colors text-sm">Sitemap</a>
          </div>
        </div>

      

        {/* Back to Top */}
        <div className="text-center mt-8">
          <a 
            href="#" 
            className="inline-flex items-center gap-2 text-amber-400 hover:text-amber-300 transition-colors text-sm"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 10l7-7m0 0l7 7m-7-7v18"></path>
            </svg>
            Back to Top
          </a>
        </div>

      </div>
    </div>
  );
};

export default Footer;